import VideoCard from '@/components/base/VideoCard';
import type { VideoItem } from '@/mocks/videos';

interface VideoGridProps {
  videos: VideoItem[];
  title?: string;
  subtitle?: string;
}

export default function VideoGrid({ videos, title, subtitle }: VideoGridProps) {
  if (videos.length === 0) {
    return (
      <div className="text-center py-16">
        <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-full bg-background-100 mb-4">
          <i className="ri-movie-line text-2xl text-foreground-300"></i>
        </div>
        <p className="text-foreground-400 text-sm">暂无相关内容</p>
      </div>
    );
  }

  return (
    <div>
      {title && (
        <div className="flex items-center justify-between mb-4">
          <div>
            <h2 className="text-lg md:text-xl font-bold font-heading text-foreground-900">{title}</h2>
            {subtitle && <p className="text-sm text-foreground-500 mt-1">{subtitle}</p>}
          </div>
        </div>
      )}
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 md:gap-4">
        {videos.map((video) => (
          <VideoCard key={video.id} video={video} />
        ))}
      </div>
    </div>
  );
}